module.exports = __webpack_public_path__ + "static/img/1_4_1.3adf34e1.jpg";